module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/indi-store/settings/store-settings.component.css
// module id = ./src/app/indi-store/settings/store-settings.component.css
// module chunks = main